import { useSiteCapabilityCheck } from '../../../common/hooks/use-site-capability-check';
import { useSource } from './use-source';

export function useInitialSelectedPowerSources() {
  const source = useSource();
  const { siteHasBattery, siteHasMeter, siteHasInverter, siteHasInverterSolar, siteHasMeterSolar } =
    useSiteCapabilityCheck();

  if (source) {
    return {
      solar: source === 'solar',
      battery: source === 'battery',
      // generator: source === 'generator',
      grid: source === 'grid',
    };
  }

  return {
    solar: siteHasInverterSolar || siteHasMeterSolar,
    battery: siteHasBattery,
    generator: false,
    grid: (siteHasBattery && siteHasInverter) || siteHasMeter,
  };
}
